import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BRAND } from "@/lib/site-data";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#process", label: "How it works" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQs" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-brand-bg/90 backdrop-blur-md border-b border-brand-line"
          : "bg-transparent"
      }`}
    >
      <div className="container-site flex items-center justify-between h-24 md:h-28">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-4 md:gap-5 text-brand-pine"
        >
          <img src="/logo.png" alt={BRAND.name} className="h-16 md:h-20 w-auto" />
          <span className="flex flex-col leading-[1.05]">
            <span className="font-serif text-xl sm:text-2xl md:text-3xl font-medium text-brand-pine">
              Home Visit <span className="text-brand-clay">Dental Treatment</span>
            </span>
            <span className="text-xs md:text-sm tracking-[0.3em] uppercase text-brand-textMuted mt-1">
              Pune & PCMC City
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-brand-text/80 hover:text-brand-clay transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            data-testid="nav-call-btn"
            className="inline-flex items-center gap-2 text-sm text-brand-pine hover:text-brand-clay"
          >
            <Phone size={16} strokeWidth={1.8} />
            {BRAND.phone}
          </a>
          <a href="#booking" data-testid="nav-book-now-btn" className="btn-primary text-sm px-5 py-2.5">
            Book a home visit
          </a>
        </div>

        <button
          className="md:hidden p-2 text-brand-pine"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-brand-bg border-t border-brand-line" data-testid="mobile-menu">
          <div className="container-site py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-brand-text/80"
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a href="#booking" onClick={() => setOpen(false)} className="btn-primary" data-testid="mobile-book-now-btn">
              Book a home visit
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
